import PropTypes from 'prop-types';
import React from 'react';
import Spinner from 'react-spinkit';

import { flag, handler } from '../../shapes';
import { nullFunc } from '../../utils/helpers';
import ErrorMsg from '../../components/ErrorMsg';
import Input from '../../components/Input';
import Money from '../../components/Money';


const ReedemCode = ({
  handleSubmit,
  isFetching,
  error,
  isValid,
  promoCode,
  onChange,
  submitEnabled,
  hasLoyaltyProgram,
  hasPromotions,
  giftCardEnabled,
  inputDisabled,
  remainingGiftCardBalance,
  hasGiftCardBalance,
  validationNote,
}) => {
  const promoLabel = (() => {
    const labels = [];
    if (hasLoyaltyProgram) labels.push('Loyalty');
    if (giftCardEnabled) labels.push('Gift Card');
    labels.push('Promo');
    const separator = (labels.length > 2) ? '/' : ' or ';
    return `${labels.join(separator)} Code`;
  })();

  if (!hasPromotions) return null;

  return (
    <form
      className="u-mt+"
      onSubmit={handleSubmit}
      disabled={isFetching}
    >
      <Input
        id="reedem"
        label={promoLabel}
        size="small"
        value={promoCode}
        onChange={onChange}
        disabled={inputDisabled}
      />
      { error && <ErrorMsg className="u-mt-- u--mb-">{error}</ErrorMsg>}
      {hasGiftCardBalance && (<div className="u-type--bold u-pb+ u-pt-">
        <span className="u-mr-- u-float-left">Remaining balance:</span>
        <span className="u-float-right">
          <Money>{remainingGiftCardBalance}</Money>
        </span>
      </div>)}
      {validationNote && (
        <div className="u-type--bold u-pv-">{validationNote}</div>
      )}
      <div className="u-text-right u-mt-">
        <button
          className="c-btn c-btn--secondary c-btn--small"
          disabled={!submitEnabled}
          type="submit"
        >
          { (() => {
            if (isFetching) return <Spinner spinnerName="double-bounce" noFadeIn />;
            if (isValid) return 'Change code';
            return 'Redeem';
          })() }
        </button>
      </div>
    </form>
  );
};
ReedemCode.propTypes = {
  handleSubmit: handler,
  isFetching: flag,
  error: PropTypes.string,
  isValid: flag,
  promoCode: PropTypes.string,
  onChange: handler,
  submitEnabled: flag.isRequired,
  hasLoyaltyProgram: flag,
  hasPromotions: flag,
  giftCardEnabled: flag,
  inputDisabled: flag,
  remainingGiftCardBalance: PropTypes.number.isRequired,
  hasGiftCardBalance: flag.isRequired,
  validationNote: PropTypes.string,
};
ReedemCode.defaultProps = {
  hasLoyaltyProgram: false,
  hasPromotions: true,
  handleSubmit: nullFunc,
  isFetching: false,
  error: '',
  isValid: false,
  promoCode: '',
  onChange: nullFunc,
  giftCardEnabled: false,
  inputDisabled: false,
  validationNote: '',
};

export default ReedemCode;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ReedemCode.jsx